const cardStyle = {
  card: {
    border: "0",
    marginBottom: "5px",
    marginTop: "5px",
    borderRadius: "6px",
    color: "rgba(0, 0, 0, 0.87)",
    background: "white",
    width: "100%",
    boxShadow:
      "0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    minWidth: "0",
    wordWrap: "break-word",
    fontSize: ".705rem",
    transition: "all 300ms linear"
  },
  cardPlain: {
    background: "#000",
    boxShadow: "5px 10px #888888"
  },
  cardCarousel: {
    overflow: "hidden"
  }
};

export default cardStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/components/cardStyle.jsx